import { LangOptions } from "./navbarModel";

export const availableLangs: LangOptions[] = [
  {
    label: 'Español',
    placeholder: 'ES',
    value: 'es',
    isoCode: 'es-ES'
  },
  {
    label: 'Català',
    placeholder: 'CA',
    value: 'ca',
    isoCode: 'ca-ES'
  },
  {
    label: 'English',
    placeholder: 'EN',
    value: 'en',
    isoCode: 'en-US'
  },
]
